
import CheckTax from '~/pages/_lang/account/new-register/check-tax'
export default CheckTax
